var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: {
                page: _vm.page,
                data: _vm.tableData,
                "table-loading": _vm.tableLoading,
                option: _vm.tableOption,
                permission: _vm.permissionList,
                "before-open": _vm.beforeOpen,
              },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "refresh-change": _vm.refreshChange,
                "size-change": _vm.sizeChange,
                "current-change": _vm.currentChange,
                "row-update": _vm.handleUpdate,
                "row-save": _vm.handleSave,
                "row-del": _vm.handleDelete,
              },
            },
            [
              _c(
                "template",
                { slot: "menuLeft" },
                [
                  _vm.permissions.sys_client_del
                    ? _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-refresh-left",
                          },
                          on: { click: _vm.handleRefreshCache },
                        },
                        [_vm._v("缓存\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }